"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDE_PATIENT_REL_FOR_LOCATIONS = void 0;
const HIDE_PATIENT_REL_FOR_LOCATIONS = exports.HIDE_PATIENT_REL_FOR_LOCATIONS = 'hide_patient_rel_for_locations';